<!-- 挂载小程序 -->
<template>
    <div :class="classNames">
        <div :class="commonName+ '_search'">
            <div :class="commonName+ '_search_con'" style="gap:10px;">
                <div v-if="dyAccountList.length">
                    <el-radio v-for="(item,index) in dyAccountList" :key="index" v-model="activeDy" :label="item.id" border @input="changeActiveDy(item)">{{ item.nickname }}</el-radio>
                </div>
                <div v-else style="line-height: 40px;">(当前无抖音号)</div>
                <div :class="[commonName+ '_search_con_item', commonName+ '_oprtation']" style="margin-left: 20px;">
                    <el-button type="primary" @click="refreshFn">
                        刷新 
                        <el-tooltip placement="top">
                            <div slot="content">
                                点击刷新更新当前视频列表
                            </div>
                            <span><i class="el-icon-question question-icon"></i></span>
                        </el-tooltip>
                    </el-button>
                </div>
            </div>
        </div>
        <div :class="classNames+'_con'">
            <div :class="classNames+'_con_table'">
                <el-table :data="tableData.list" :header-cell-style="{background: '#F5F7FA',color:'#454D53'}" height="500" v-tableLoadMore="tableLoadMoreFn">
                    <div slot="empty">
                        <img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
                    </div>
                    <el-table-column v-for="(item, index) in headerList" :key="index" :prop="item.prop" :label="item.label" :width="item.width" :align="item.align">
                        <template slot-scope="scope">
                            <div v-if="item.prop=='orderNumber'">
                                {{ scope.$index+1 }}
                            </div>
                            <div v-else-if="item.prop == 'videoInfo'">
                                <videoInfo :itemObj="scope.row"></videoInfo>
                            </div>
                            <div v-else-if="item.prop == 'status'">
                                {{ statusObj[scope.row[item.prop]].label }}
                            </div>
                            <div v-else>{{scope.row[item.prop] || '--'}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120">
                        <template slot-scope="scope">
                            <div class="operate-box">
                                <div class="operate-item" :class="commonName+'_operation_title'"  @click="handleOperate(1, scope.row)">挂小程序</div>
                            </div>
                        </template>
                    </el-table-column>
                    <div slot="append" v-show="searchObj.isLoading && searchObj.cursor!=0" style="width: 100%; text-align: center;padding: 20px 0;">
                        <i class="el-icon-loading"></i> 加载中...
                    </div>
                </el-table>
            </div>
        </div>
        <modalPop v-model="dyAccountPopObj.showPop" title="提示" @sureBtnFn="dyAccountPopSure" :sureClose="false">
            <div class="dy-account-pop">
                <div class="title" v-if="getCurrentDyItem">请输入 {{ getCurrentDyItem.nickname }}（抖音昵称）的抖音号</div>
                <el-input v-model="dyAccountPopObj.aweme_id" placeholder="请输入内容"></el-input>
            </div>
        </modalPop>
        <modalPop v-model="dyErrorPopObj.showPop" sureText="去检查" @sureBtnFn="dyErrorPopSure" title="提示">
            <div>
                <p>当前用户id不存在，请检查抖音号是否正确</p>
            </div>
        </modalPop>
        <modalPop v-model="showTipPop" title="提示" sureText="我知道了" :showCancelBtn="false">
            <p>请联系客服开通已发布的短视频中挂载小程序&查询作者视频能力</p>
        </modalPop>
        <modalPop v-model="mountMiniPopObj.showPop" title="选择挂载页面" :sureClose="false" @sureBtnFn="mountMiniPopSure">
            <div class="mount-mini-pop">
                <el-radio-group v-model="mountMiniPopObj.mount_type">
                    <el-radio-button v-for="item in mountTypeList" :key="item.id" :label="item.id">{{ item.label }}</el-radio-button>
                </el-radio-group>
                <div class="select-box" v-if="mountMiniPopObj.mount_type==1">
                    <el-select v-model="mountMiniPopObj.product_id" placeholder="选择要挂载的课程" style="width: 70%;">
                        <el-option
                            v-for="item in classList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </modalPop>
    </div>
</template>

<script>
    import { headerList } from './data.js'
    import videoInfo from './components/videoInfo.vue'
    import modalPop from '@/components/modalPop/modalPop.vue'
    import { throttle } from 'lodash-unified'
    import { mapActions } from 'vuex'
    export default {
        components: {
            videoInfo,
            modalPop
        },
        data(){
            return {
                classNames: 'comment',
                noDataName: 'empty',
                headerList: headerList,
                activeDy: '', // 当前抖音
                tableData: {// 表格数据
                    list: []
                },
                searchObj: {
                    cursor: 0,
                    aweme_id: '',
                    isLoading: false,
                    haveMore: true
                },
                dyAccountList: [], // 抖音号列表
                dyAccountPopObj: { // 输入抖音号弹窗相关
                    showPop: false,
                    aweme_id: ''
                },
                mountTypeList:[ // 挂载小程序页面类型
                    {id: 1, label: '课程详情'},
                    {id: 2, label: '讲师主页'}
                ],
                statusObj: { // 状态obj
                    1: {label: '已挂载'},
                    2: {label: '未挂载'},
                },
                mountMiniPopObj: { // 挂载小程序弹窗相关
                    showPop: false,
                    mount_type: 1, // 挂载类型: 1=课程挂载,2=讲师主页
                    product_id: '', // 课程id
                    video_id: '', // 抖音视频id
                },
                classList: [], // 课程列表
                dyErrorPopObj: { // 抖音号错误弹窗
                    showPop: false
                },
                showTipPop: false // 提示弹窗
            }
        },
        created(){
            this.getDyList()
            this.getClassList()
        },
        computed: {
            // 获取当前抖音号item
            getCurrentDyItem(){
                if(this.dyAccountList.length){
                    return this.dyAccountList.find(item=>item.id==this.activeDy)
                }
            },
        },
        methods: {
            ...mapActions('class',['courseGetcourse']),
            ...mapActions('market',['getBindedDyListAPI', 'updateDyAccountAPI', 'getDyWorksListAPI', 'mountMiniVideoAPI']),
            // 抖音号有误弹窗 点击确定 
            dyErrorPopSure(){
                this.dyAccountPopObj.aweme_id = this.getCurrentDyItem.aweme_id || ''
                this.dyAccountPopObj.showPop = true
            },
            // 点击抖音号
            changeActiveDy(item){
                this.searchObj.aweme_id = item.aweme_id || ''
                this.getTableData(true)
            },
            // table触底
            tableLoadMoreFn:throttle(function(){
                this.getTableData()
            },600),
            // 获取可挂载课程列表
            async getClassList(){
                let res = await this.courseGetcourse({
                    status: 1
                })
                // console.log('getClassList-res:',res)
                this.classList = res.data || []
            },
            // 挂载小程序弹窗点击确认
            async mountMiniPopSure(){
                let { mount_type, product_id, video_id } = this.mountMiniPopObj
                let { aweme_id, id } = this.getCurrentDyItem
                if(mount_type==1 && !product_id) return this.$message.error('请选择要挂载的课程')
                let res = await this.mountMiniVideoAPI({
                    video_id,
                    product_id,
                    aweme_id,
                    dycode_id: id,
                    mount_type
                })
                console.log('mountMiniPopSure-res:',res)
                this.$message({
                    message: '挂载成功',
                    type: 'success'
                })
                this.getTableData(true)
                this.mountMiniPopObj.showPop = false
            },
            // 输入抖音号弹窗点击确认
            dyAccountPopSure: throttle(async function(){
                if(!this.dyAccountPopObj.aweme_id){
                    this.$message.error('请输入抖音号')
                    return
                }
                let res = await this.updateDyAccountAPI({
                    taid: this.getCurrentDyItem.taid,
                    dycode_id: this.getCurrentDyItem.id,
                    aweme_id: this.dyAccountPopObj.aweme_id
                })
                this.dyAccountPopObj.showPop = false
                this.$message({
                    message: '修改成功',
                    type: 'success'
                })
                this.getDyList()
            },1000),
            // 获取抖音号列表
            async getDyList(){
                let res = await this.getBindedDyListAPI({
                    page: 1,
                    limit: 1000
                })
                this.dyAccountList = res.data || []
                if(res.data.length){
                    this.activeDy = res.data[0].id // 抖音dycode_id
                    this.searchObj.aweme_id = res.data[0].aweme_id || ''
                    this.getTableData(true)
                }else{
                    this.showTipPop = true
                }
            },
            // 操作
            handleOperate(type, item){
                if(type==1){ // 挂小程序
                    if(item.mount_type){
                        this.mountMiniPopObj.mount_type = item.mount_type
                    }else{
                        this.mountMiniPopObj.mount_type = 1
                    }
                    if(item.product_id){
                        this.mountMiniPopObj.product_id = item.product_id
                    }else{
                        this.mountMiniPopObj.product_id = ''
                    }
                    this.mountMiniPopObj.video_id = item.dy_video_id
                    this.mountMiniPopObj.showPop = true
                    console.log('handleOperate-item:',item)
                }
            },
            // 刷新按钮
            refreshFn(){
                if(this.dyAccountList.length){
                    this.getTableData(true)
                }else{
                    this.showTipPop = true
                }
            },
            // 获取表格数据
            async getTableData(flag){
                if(!this.searchObj.aweme_id && this.dyAccountList.length){ // 当前抖音未填写抖音账号
                    this.$nextTick(()=>{
                        this.dyAccountPopObj.aweme_id = ''
                        this.dyAccountPopObj.showPop = true
                    })
                    return
                }
                if(!this.getCurrentDyItem.mount_enable){
                    this.showTipPop = true
                    return
                }
                if(flag) this.searchObj.isLoading = false
                if(this.searchObj.isLoading) return
                this.searchObj.isLoading = true
                if(flag){
                    this.tableData.list = []
                    this.searchObj.cursor = 0
                    this.searchObj.haveMore = true
                }
                if(!this.searchObj.haveMore) return
                try{
                    let { cursor, aweme_id } = this.searchObj
                    let res = await this.getDyWorksListAPI({
                        cursor,
                        aweme_id
                    })
                    console.log('getTableData-res:',res)
                    this.searchObj.cursor = res.max_cursor || ''
                    if(flag){
                        this.tableData.list = res.data || []
                    }else{
                        this.tableData.list = [...this.tableData.list, ...res.data]
                    }
                    if(!res.data.length || !res.has_more) this.searchObj.haveMore = false
                    this.searchObj.isLoading = false

                }catch(err){ 
                    if(err.code==555){
                        this.dyErrorPopObj.showPop = true
                    }
                }
            },
        }
    }
</script>

<style scoped lang="less">
.dy-account-pop{
    .title{
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: 500;
    }
}
.mount-mini-pop{
    .select-box{
        margin-top: 10px;
    }
}
</style>